import React, { useEffect, useRef } from 'react';
import { authNegotiate, storeUser, unloadUser } from '../slices/global/authSlice';
import { signoutRedirect, getRoleClaims } from './userService';
import { createCookie, eraseCookie } from './utils';

export default function AuthProvider({ userManager: manager, store, children }) {
  let userManager = useRef();

  useEffect(() => {
    userManager.current = manager;

    const onUserLoaded = async (user) => {
      console.log(`user loaded`);
      store.dispatch(authNegotiate());
      await getRoleClaims(store, user).then(() => store.dispatch(storeUser(user)));

      createCookie('roleId', user.profile.role, 1);
      createCookie('username', user.profile.email, 1);
    };

    const onUserUnloaded = () => {
      //Unload axios header here
      console.log(`user unloaded`);
      store.dispatch(unloadUser());
      eraseCookie('roleId');
      eraseCookie('username');
    };

    const onAccessTokenExpiring = () => {
      console.log(`user token expiring`);
    };

    const onAccessTokenExpired = () => {
      console.log(`user token expired`);
      store.dispatch(unloadUser());
      signoutRedirect();
    };

    const onUserSignedOut = () => {
      console.log(`user signed out`);
      //   store.dispatch(unloadUser());
    };

    // events for user
    userManager.current.events.addUserLoaded(onUserLoaded);
    userManager.current.events.addUserUnloaded(onUserUnloaded);
    userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
    userManager.current.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.current.events.addUserSignedOut(onUserSignedOut);

    // Specify how to clean up after this effect:
    return function cleanup() {
      userManager.current.events.removeUserLoaded(onUserLoaded);
      userManager.current.events.removeUserUnloaded(onUserUnloaded);
      userManager.current.events.removeAccessTokenExpiring(onAccessTokenExpiring);
      userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
      userManager.current.events.removeUserSignedOut(onUserSignedOut);
    };
  }, [manager, store]);

  return React.Children.only(children);
}
